// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CrmServiceability from "../entity/CrmServiceability.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function decodeHelperServiceabilityInfo(serviceability_json) {
  return DeccoUtils$Catalyst.resolveResult(CrmServiceability.t_decode(serviceability_json), "ServiceabilityStateMapper.re");
}

function decodeOutStationServiceabilityInfo(serviceability_json) {
  return DeccoUtils$Catalyst.resolveResult(CrmServiceability.t_decode(serviceability_json), "ServiceabilityStateMapper.re");
}

function decodeRentalServiceabilityInfo(serviceability_json) {
  return DeccoUtils$Catalyst.resolveResult(CrmServiceability.t_decode(serviceability_json), "ServiceabilityStateMapper.re");
}

export {
  decodeHelperServiceabilityInfo ,
  decodeOutStationServiceabilityInfo ,
  decodeRentalServiceabilityInfo ,
  
}
/* CrmServiceability Not a pure module */
